module.exports = __webpack_public_path__ + "static/img/system_header.7a3dd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/system_header.png
// module id = mPzE
// module chunks = 2